/**
 * Project-level settings that are safe to commit (sandbox-only).
 *
 * Why this file exists instead of `.env`:
 *   `.env.*` files are gitignored, which means every collaborator has to set
 *   up their own copy before the app runs. For *sandbox* credentials that's
 *   wasteful — Square sandbox keys are public-test-only, no money moves, so
 *   we commit them.
 *
 * Production deploys should override these from the build environment (e.g.
 *   `GATSBY_SQUARE_APP_ID=… gatsby build`). Never commit live keys here.
 */

// ---------- Backend API host (mirrors the supplier portal's settings.ts) ----------
//
// Environment is chosen by BUILD flags, not a runtime URL:
//   - `gatsby build` with GATSBY_BUILD_PROD=true     → production
//   - `gatsby build` with GATSBY_BUILD_STAGING=true  → demo / staging
//   - `gatsby build` on a dev's machine (neither)    → BackendUrl[LocalBuildKey]
//   - `gatsby develop` (NODE_ENV !== 'production')   → DEV (local, NOT production)
//
// buyer-portal.ts appends `/api/v1` to this and lets GATSBY_API_BASE_URL override.
export const isBuild = process.env.NODE_ENV === 'production';
export const isProduction = isBuild && process.env.GATSBY_BUILD_PROD === 'true';
export const isDemo = isBuild && process.env.GATSBY_BUILD_STAGING === 'true';
export const isBuildingOnDevice = isBuild && !isDemo && !isProduction;

const BackendUrl = {
  DEMO: 'https://demo-practitioner-api.healthnex.com.au',
  PRODUCTION: 'https://vmallapi.healthnex.com.au',
  // LAN / local dev backends — switch DEV below as needed.
  SUPPLIER_DEV: 'http://192.168.0.164:5127',
  LOCALHOST: 'http://localhost:5127',
};

// Backend used by a flagless `gatsby build` (isBuildingOnDevice). Defaults to
// PRODUCTION so an existing buyer-portal deploy that doesn't set
// GATSBY_BUILD_PROD keeps hitting the production API (its prior behaviour).
const LocalBuildKey: 'DEMO' | 'PRODUCTION' = 'PRODUCTION';
// Backend used by `gatsby develop` (everyday local dev).
const DevBackend = BackendUrl.SUPPLIER_DEV;

export const backEndBaseURL = isDemo
  ? BackendUrl.DEMO
  : isProduction
  ? BackendUrl.PRODUCTION
  : isBuildingOnDevice
  ? BackendUrl[LocalBuildKey]
  : DevBackend;

// ---------- Square Web Payments SDK ----------

const SQUARE_SANDBOX_ID = 'sandbox-sq0idb-7wkiUlmjTmYIXmjkpTv9ww';
const SQUARE_PRODUCTION_ID = 'sq0idp-gxIjm6fNU1jd5oAiojnUYw';

export const SQUARE_ENVIRONMENT: 'sandbox' | 'production' =
  process.env.GATSBY_SQUARE_ENV === 'production' ? 'production' : 'sandbox';

export const SQUARE_APP_ID: string =
  process.env.GATSBY_SQUARE_APP_ID ||
  (SQUARE_ENVIRONMENT === 'production' ? SQUARE_PRODUCTION_ID : SQUARE_SANDBOX_ID);

export const SQUARE_SDK_URL: string =
  SQUARE_ENVIRONMENT === 'production'
    ? 'https://web.squarecdn.com/v1/square.js'
    : 'https://sandbox.web.squarecdn.com/v1/square.js';
